import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import React from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import FieldSelect from "../../Table/FieldSelect"
import Typography from "@material-ui/core/Typography"
import { usePhotoModalStyle } from "./style"
import { useUpdate } from "./hooks"

const Update = () => {
    const classes = usePhotoModalStyle()
    const {
        callback, cancelCallback, dialogData,
        disabled, dateStr, text, handleChange, handleChangeArticleType, external,
        isBusiness, isMine, isPass,
        projectMoney, handleProjectMoneyChange,
        projectId, handleProjectIdChange,
    } = useUpdate()
    const isTwoDay = dialogData.date.getTime() - new Date().getTime() < 1 * 24 * 3600 * 1000
    return (
        <BoardConfirmModal
            title="修改预约说明"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    disabled={isPass && isBusiness}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl disabled={isPass && isBusiness} className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        rowData={{
                            photo_article_type_id: external.articleTypeId,
                        }}
                        staticValueList={[]}
                        tableName="photo_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>

            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine ? (
                    <>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
            {
                isBusiness && isTwoDay ? (
                    <>
                        <Grid container justify="flex-start" alignItems="center" className={classes.input}>
                                <Typography color="initial">
                                    注意：2天内的预约不可删除哦~
                                </Typography>
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default Update
